<template>
  <button
    class="svoi-button"
    :class="[classes, classLoading]"
    :disabled="disabled || loading"
    :type="type"
    :tabindex="tabindex"
    :qa-locator="qaLocator"
    @click="$emit('click')"
  >
    <SvoiTooltippedIcon v-if="iconLeft && !loading" :icon="iconLeft" :size="iconSize" class="icon-left" />
    <span v-if="loading && loaderIconLeft" class="loader loader-left"></span>

    <slot name="name" :bindClass="'name'">
      <span v-if="name" class="name">{{ name }}</span>
    </slot>

    <SvoiTooltippedIcon v-if="iconRight && !loading" :icon="iconRight" :size="iconSize" class="icon-right" />
    <span v-if="loading && loaderIconRight" class="loader loader-right"></span>
  </button>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue-demi'
import { SvoiTooltippedIcon } from '@svoi-ui/components/icon'
import type { Type } from '@svoi-ui/interfaces/button'
import { isString } from '@svoi-ui/shared/utils/guards'
import { buttonLocator } from '@svoi-ui/shared/utils/helpers'
import { BaseButtonComponent, useBaseButton } from './BaseButton'

export default defineComponent({
  name: 'SvoiButton',
  components: { SvoiTooltippedIcon },
  props: {
    ...BaseButtonComponent.props,
    type: {
      type: String as PropType<Type | string>,
      default: 'button',
      validator: (value: unknown) => {
        return isString(value) && ['submit', 'button', 'reset'].includes(value)
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    loaderIconLeft: {
      type: Boolean,
      default: true
    },
    loaderIconRight: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click', 'mouseover', 'mouseleave', 'focus'],
  setup(props) {
    const { classes, iconSize } = useBaseButton(props)

    const classLoading = computed(() => {
      return { '-loading -theme-loading': props.loading }
    })
    const qaLocator = computed(() => (props.qaLocator ? buttonLocator(props.qaLocator) : undefined))

    return { classes, iconSize, classLoading, qaLocator }
  },
  methods: { isString }
})
</script>

<style lang="scss">
@use '@svoi-ui/assets/scss/components/button.scss';
</style>
